import React, { useEffect, useState } from 'react';

import ApngComponent from 'react-apng';

const ImageAnimation = ({ imageUrl, onClick, style }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Preload image and sound
  useEffect(() => {
    const preloadAssets = async () => {
      const promises = [];

      // Preload image
      if (imageUrl) {
        const imgPromise = new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = imageUrl;
        });
        promises.push(imgPromise);
      }

      try {
        await Promise.all(promises);
        setIsLoaded(true);
      } catch (error) {
        console.error('Error preloading assets:', error);
        // Set loaded anyway to show content even if preload fails
        setIsLoaded(true);
      }
    };

    preloadAssets();
  }, [imageUrl]);

  if (!isLoaded) {
    return null; // or return a loading spinner
  }

  return (
    <>
      <ApngComponent
        src={imageUrl}
        autoPlay={true} // Disable default autoplay
        style={{
          ...style,
        }}
        onClick={() => {
          if (onClick) onClick();
        }}
      />
    </>
  );
};

export default ImageAnimation;
